import flavourConfig from 'config';

export const getPublicUrlForImage = (imagePath: string): string => `${flavourConfig.UI_BASE_URL}/${imagePath}`;
